<p-card class="mb-4">
    <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12 sm:col-span-6 md:col-span-4 2xl:col-span-3">
            <p-select class="multiselect-stocks" [options]="states" [(ngModel)]="filters.condition" [filter]="false" fluid [showClear]="true" placeholder="État du stock" optionLabel="name" optionValue="value" display="chip" fluid  (onChange)="onSelectChange($event)">
                <ng-template let-selectedStates #selectedItem>
                    @if (selectedStates) {
                        <p-tag [severity]="utilityService.getStateSeverity(selectedStates.code)" [value]="utilityService.getStateLabel(selectedStates.code)"/>
                    }
                </ng-template>
                <ng-template let-state #item>
                    <p-tag [severity]="utilityService.getStateSeverity(state.code)" [value]="utilityService.getStateLabel(state.code)" />
                </ng-template>
            </p-select>
        </div>

        <div class="col-span-12 sm:col-span-6 md:col-span-4 2xl:col-span-3">
            <p-select class="multiselect-stocks" [options]="directions" [(ngModel)]="filters.direction" [filter]="false" fluid [showClear]="true" placeholder="Type d'écart" optionLabel="name" optionValue="code" fluid  (onChange)="onSelectChange($event)"></p-select>
        </div>

        <div class="col-span-12 sm:col-span-6 md:col-span-4 2xl:col-span-3">
            <p-select class="multiselect-stocks" [options]="seuilsEcart" [(ngModel)]="filters.seuil_pourcentage" [filter]="false" fluid [showClear]="true" placeholder="Seuil Pourcentage" fluid  (onChange)="onSelectChange($event)">
                <ng-template let-selectedValue #selectedItem>
                    <span [class]="utilityService.getPriceAbsoluteColor(selectedValue)">{{ (selectedValue / 100) | percent:'1.0-0' }}</span>
                </ng-template>
                <ng-template let-value #item>
                    <span [class]="utilityService.getPriceAbsoluteColor(value)">{{ (value / 100) | percent:'1.0-0' }}</span>
                </ng-template>
            </p-select>
        </div>

        <div class="col-span-12 sm:col-span-6 md:col-span-4 2xl:col-span-3">
            <p-button label="Réinitialiser" icon="pi pi-undo" iconPos="right" (click)="onClear()" text />
        </div>
    </div>
</p-card>

<p-card>
    <p-table
        #dt
        [value]="ebayStockPrices"
        dataKey="stock_id"
        [lazy]="true"
        [paginator]="true"
        [totalRecords]="resultsLength"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="{first} - {last} sur {totalRecords}"
        [rows]="pageSize"
        [rowsPerPageOptions]="[10, 20, 50]"
        sortField="ecart_pourcentage"
        [sortOrder]="-1"
        [(selection)]="selectedEbayStockPrice"
        [columns]="selectedColumns"
        [loading]="isLoadingResults"
        [scrollable]="true"
        scrollHeight="634px"
        (onLazyLoad)="onLazyLoad($event)"
        (onStateRestore)="onStateRestore($event)"
        stateKey="_ssk"
        stateStorage="local"
        [defaultSortOrder]="-1"
    >
        <ng-template #header let-columns>
            <tr>
                @for (col of columns; track $index) {
                    <th>{{ col.header }}</th>
                }
            </tr>
        </ng-template>

        <ng-template #body let-ebayStockPrice let-columns="columns">
            <tr>
                @for (col of columns; track $index) {
                    @switch (col.field) {
                        @case ('produit_id') {
                            <td>
                                <a [routerLink]="['/products', ebayStockPrice.produit_id]" [queryParams]="{stock_id: ebayStockPrice.stock_id}" class="flex flex-col justify-center items-center">
                                    <img [src]="apiUrl + ebayStockPrice.photo_couverture" alt="{{ebayStockPrice.reference}}" width="80" height="80" class="h-20 w-20 shadow-lg object-cover rounded-md" />
                                    <p-tag severity="contrast" [value]="'#' + ebayStockPrice.produit_id" class="-mt-3 relative z-0 !text-base" />
                                </a>
                            </td>
                        }
                        @case ('etat') {
                            <td><p-tag [severity]="utilityService.getStateSeverity(ebayStockPrice.etat)" [value]="utilityService.getStateLabel(ebayStockPrice.etat)" class="mt-2" /></td>
                        }
                        @case ('prix_marche_median') {
                            <td>{{ ebayStockPrice[col.field] | currency:'EUR' }}</td>
                        }
                        @case ('prix_stock') {
                            <td>{{ ebayStockPrice[col.field] | currency:'EUR' }}</td>
                        }
                        @case ('ecart_pourcentage') {
                            <td [class]="utilityService.getPriceAbsoluteColor(ebayStockPrice[col.field])">{{ (ebayStockPrice[col.field] / 100) | percent:'1.2-2' }}</td>
                        }
                        @case ('date_analyse') {
                            <td>{{ ebayStockPrice[col.field] | date:'shortDate' }}</td>
                        }
                        @default {
                            <td>{{ ebayStockPrice[col.field] }}</td>
                        }
                    }
                }
            </tr>
        </ng-template>
    </p-table>
</p-card>
